function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 11,
  width: 8,
  height: 2,
  fill: "#616B70"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.9972 9.34869 20.9427 6.80678 19.068 4.93202C17.1932 3.05727 14.6513 2.0028 12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17316C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8078C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557ZM20.4615 12C20.4615 10.3265 19.9653 8.69051 19.0355 7.29902C18.1057 5.90753 16.7842 4.82299 15.2381 4.18256C13.6919 3.54212 11.9906 3.37456 10.3492 3.70105C8.70786 4.02754 7.20016 4.83342 6.01679 6.01679C4.83343 7.20016 4.02754 8.70786 3.70105 10.3492C3.37456 11.9906 3.54213 13.6919 4.18256 15.2381C4.823 16.7842 5.90753 18.1057 7.29902 19.0355C8.69052 19.9653 10.3265 20.4615 12 20.4615C14.2434 20.459 16.3941 19.5667 17.9804 17.9804C19.5667 16.3941 20.459 14.2434 20.4615 12Z",
  fill: "#616B70"
});

var SvgLoseSmall = function SvgLoseSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoseSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LoseSmall.de7066bf.svg";
export { ForwardRef as ReactComponent };